define("calendar/components/calendar/stories/editor", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service", "@ember/object", "@ember/utils", "later/utils/time-format", "shared/utils/uuid", "moment"], function (_exports, _component, _templateFactory, _component2, _service, _object, _utils, _timeFormat, _uuid, _moment) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _formatStoryTime;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"@ember/object",0,"@ember/utils",0,"later/utils/time-format",0,"shared/utils/uuid",0,"moment",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cST--container--bottom u--fadeIn ember-view">
    {{#if this.showDropZone}}
      <Calendar::Stories::DropZone
        @onDrop={{this.addMediaToStory}}
        @scrollToRight={{this.scrollToRight}}
        data-test-id="drop-zone"
      />
    {{/if}}
    <div class="cST--content {{if this.isPostedStory "is--posted"}}" data-test-id="editor">
      {{!Story Toolbar}}
      <div class="cSE--header">
        {{#if this.isPostedStory}}
          <span class="u--float--left u--m__t__xs">
            {{t "stories.story_editor.story_went_live_on" postedTime=this.storyFormattedPostedTime}}
          </span>
          <div class="o--btnBar u--float--right">
            <a
              class="o--btn o--btn--primary u--p__lr__lg"
              data-test-id="posted-done-button"
              {{on "click" @clearSelectedStory}}
            >
              {{t "shared_words.done"}}
            </a>
          </div>
        {{else}}
          <div class="o--btnBar u--float--left">
            <a
              class="o--btn o--btn--outline cST--header__btn"
              data-test-id="discard-story-button"
              {{on "click" this.discardStory}}
            >
              {{t "stories.story_editor.discard_story"}}
            </a>
            {{#if @notNewAndHasChanges}}
              <a class="o--btn o--btn--mute" data-test-id="discard-changes-button" {{on "click" @discardChangesAndClose}}>
                {{t "stories.story_editor.discard_changes"}}
              </a>
            {{/if}}
          </div>
          <div class="o--btnBar u--float--right">
            <div class="o--btnGroup cST--header__btnGroup">
              <Shared::DateTimePicker
                @altFormat="Y/m/d h:i K"
                @dateTime={{@story.scheduledTime}}
                @disabled={{@story.isSaving}}
                @enableTime={{true}}
                @inputClass="o--btn o--btn--outline e--modal__action__scheduleDate"
                @minuteIncrement="15"
                @onDateChange={{this.updateScheduledTime}}
                @pickerClass="o--btnGroup"
                @showScheduleIcon={{true}}
              />
            </div>
            {{#if @hasUnsavedChanges}}
              <a
                class="o--btn o--btn--primary u--p__lr__lg {{if this.canSaveStory "" "o--btn--disabled"}}"
                data-test-id="save-story-button"
                {{on "click" this.saveStory}}
              >
                {{t "stories.story_editor.save"}}
              </a>
            {{else}}
              <a
                class="o--btn o--btn--outline u--p__lr__lg u--text--hl"
                data-test-id="unposted-done-button"
                {{on "click" @clearSelectedStory}}
              >
                {{t "shared_words.done"}}
              </a>
            {{/if}}
          </div>
        {{/if}}
      </div>
      {{!Story Content}}
      <div class="cSE--container gd--story--3">
        {{!Story Details }}
        <div class="u--p u--clearfix">
          {{#if this.isPostedStory}}
            <p class="u--float--left u--m__b__xs">
              <span class="u--text--bold">
                {{t "stories.story_editor.play_time"}}
              </span>
              {{this.storyFormattedTotalTime}}
            </p>
          {{else}}
            <div class="u--float--left">
              <p class="u--m__b__xs" data-test-id="total-play-time">
                <span class="u--text--bold">
                  {{t "stories.story_editor.play_time"}}
                </span>
                {{this.storyFormattedTotalTime}}
              </p>
              <p class="u--m__b__xs" data-test-id="start-end-times">
                <span class="u--text--bold">
                  {{t "stories.story_editor.scheduled"}}
                </span>
                {{this.storyFormattedStartTime}}
                -
                {{this.storyFormattedEndTime}}
              </p>
            </div>
            <div class="u--float--right u--text--right">
              {{#if this.canSaveStory}}
                <p class="u--m__b__xs u--text--sm u--text--light">
                  {{t "posts.modal.instagram.n_connected_devices" count=this.socialProfileDeviceCount}}
                </p>
              {{else}}
                <p class="u--text--danger u--text--sm u--m__b__xs">
                  {{t "stories.story_editor.video_too_long" length=@invalidLengthStoryVideos.length}}
                </p>
              {{/if}}
              <a class="u--m__b__xs u--text--sm" {{on "click" @toggleTutorialModal}}>
                {{t "stories.story_editor.how_to_publish"}}
              </a>
            </div>
          {{/if}}
        </div>
        {{!Story Preview}}
        {{#if this.isPostedStory}}
          <div class="cSE--galleryWrapper eSE--galleryWrapper">
            <div class="cSE--gallery">
              {{#each @story.postMediaItems as |postMediaItem|}}
                <span class="cSE--gallery__item">
                  <figure class="o--mediaContainer">
                    <img src={{postMediaItem.medResUrl}} class="o--media cSE--gallery__media" />
                    <b class="o--mediaOverlay"></b>
                  </figure>
                </span>
              {{/each}}
            </div>
          </div>
        {{else}}
          <div class="cSE--galleryWrapper cSE--galleryWrapper--hasBtn eSE--galleryWrapper">
            <a
              class="o--btn--sm o--btn--outline o--btn--c cSE--galleryBtn cSE--galleryBtn--left"
              {{on "click" (fn this.scrollToLeftBy 150)}}
            >
              {{svg-jar "nav-left" class="o--icon--sm"}}
            </a>
            <ul class="cSE--gallery" {{perfect-scroll this.scrollbarId wheelPropagation=true maxScrollbarLength=150}}>
              <Calendar::Stories::Thumbnails
                @postMediaItems={{this.postMediaItems}}
                @canCropOnPost={{this.canCropOnPost}}
                @canDeleteStoryItems={{this.canDeleteStoryItems}}
                @groupId={{this.currentGroup.id}}
                @storyVideoMaxLength={{@storyVideoMaxLength}}
                @editPMICrop={{@editPMICrop}}
                @deleteStoryItem={{this.deleteStoryItem}}
              />
              <li class="cSE--gallery__item is--empty">
                {{#if this.showDropZone}}
                  <div class="cDZ--dropzone"></div>
                {{/if}}
                <span>
                  {{#if this.showDropZone}}
                    {{svg-jar "add-circle" class="o--icon o--icon--hl cSE--gallery__icon--empty"}}
                  {{else}}
                    {{svg-jar "add-circle" class="o--icon o--icon--light cSE--gallery__icon--empty"}}
                  {{/if}}
                  <EmberTooltip @delay={{100}} @side="top">
                    {{t "stories.story_editor.dropzone_tooltip"}}
                  </EmberTooltip>
                </span>
              </li>
              <li class="cSE--gallery__item cSE--gallery__item--textarea">
                <label class="u--block">
                  {{t "stories.story_editor.textarea_label"}}
                </label>
                <Textarea
                  class="cSE--gallery__textarea"
                  @value={{@story.caption}}
                  placeholder={{t "stories.story_editor.textarea_placeholder"}}
                  data-test-id="clipboard-text-area"
                />
              </li>
            </ul>
            <a
              class="o--btn--sm o--btn--outline o--btn--c cSE--galleryBtn cSE--galleryBtn--right"
              {{on "click" (fn this.scrollToRightBy 150)}}
            >
              {{svg-jar "nav-right" class="o--icon--sm"}}
            </a>
          </div>
        {{/if}}
      </div>
    </div>
  </div>
  
  */
  {
    "id": "ALphH0dF",
    "block": "[[[10,0],[14,0,\"cST--container--bottom u--fadeIn ember-view\"],[12],[1,\"\\n\"],[41,[30,0,[\"showDropZone\"]],[[[1,\"    \"],[8,[39,1],[[24,\"data-test-id\",\"drop-zone\"]],[[\"@onDrop\",\"@scrollToRight\"],[[30,0,[\"addMediaToStory\"]],[30,0,[\"scrollToRight\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,0],[15,0,[29,[\"cST--content \",[52,[30,0,[\"isPostedStory\"]],\"is--posted\"]]]],[14,\"data-test-id\",\"editor\"],[12],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"cSE--header\"],[12],[1,\"\\n\"],[41,[30,0,[\"isPostedStory\"]],[[[1,\"        \"],[10,1],[14,0,\"u--float--left u--m__t__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"stories.story_editor.story_went_live_on\"],[[\"postedTime\"],[[30,0,[\"storyFormattedPostedTime\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--btnBar u--float--right\"],[12],[1,\"\\n          \"],[11,3],[24,0,\"o--btn o--btn--primary u--p__lr__lg\"],[24,\"data-test-id\",\"posted-done-button\"],[4,[38,3],[\"click\",[30,1]],null],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"shared_words.done\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"o--btnBar u--float--left\"],[12],[1,\"\\n          \"],[11,3],[24,0,\"o--btn o--btn--outline cST--header__btn\"],[24,\"data-test-id\",\"discard-story-button\"],[4,[38,3],[\"click\",[30,0,[\"discardStory\"]]],null],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"stories.story_editor.discard_story\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"            \"],[11,3],[24,0,\"o--btn o--btn--mute\"],[24,\"data-test-id\",\"discard-changes-button\"],[4,[38,3],[\"click\",[30,3]],null],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"stories.story_editor.discard_changes\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--btnBar u--float--right\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--btnGroup cST--header__btnGroup\"],[12],[1,\"\\n            \"],[8,[39,4],null,[[\"@altFormat\",\"@dateTime\",\"@disabled\",\"@enableTime\",\"@inputClass\",\"@minuteIncrement\",\"@onDateChange\",\"@pickerClass\",\"@showScheduleIcon\"],[\"Y/m/d h:i K\",[30,4,[\"scheduledTime\"]],[30,4,[\"isSaving\"]],true,\"o--btn o--btn--outline e--modal__action__scheduleDate\",\"15\",[30,0,[\"updateScheduledTime\"]],\"o--btnGroup\",true]],null],[1,\"\\n          \"],[13],[1,\"\\n\"],[41,[30,5],[[[1,\"            \"],[11,3],[16,0,[29,[\"o--btn o--btn--primary u--p__lr__lg \",[52,[30,0,[\"canSaveStory\"]],\"\",\"o--btn--disabled\"]]]],[24,\"data-test-id\",\"save-story-button\"],[4,[38,3],[\"click\",[30,0,[\"saveStory\"]]],null],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"stories.story_editor.save\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[11,3],[24,0,\"o--btn o--btn--outline u--p__lr__lg u--text--hl\"],[24,\"data-test-id\",\"unposted-done-button\"],[4,[38,3],[\"click\",[30,1]],null],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"shared_words.done\"],null]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"cSE--container gd--story--3\"],[12],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"u--p u--clearfix\"],[12],[1,\"\\n\"],[41,[30,0,[\"isPostedStory\"]],[[[1,\"          \"],[10,2],[14,0,\"u--float--left u--m__b__xs\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"stories.story_editor.play_time\"],null]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[1,[30,0,[\"storyFormattedTotalTime\"]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,0],[14,0,\"u--float--left\"],[12],[1,\"\\n            \"],[10,2],[14,0,\"u--m__b__xs\"],[14,\"data-test-id\",\"total-play-time\"],[12],[1,\"\\n              \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n                \"],[1,[28,[35,2],[\"stories.story_editor.play_time\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[1,[30,0,[\"storyFormattedTotalTime\"]]],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,2],[14,0,\"u--m__b__xs\"],[14,\"data-test-id\",\"start-end-times\"],[12],[1,\"\\n              \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n                \"],[1,[28,[35,2],[\"stories.story_editor.scheduled\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[1,[30,0,[\"storyFormattedStartTime\"]]],[1,\"\\n              -\\n              \"],[1,[30,0,[\"storyFormattedEndTime\"]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,0],[14,0,\"u--float--right u--text--right\"],[12],[1,\"\\n\"],[41,[30,0,[\"canSaveStory\"]],[[[1,\"              \"],[10,2],[14,0,\"u--m__b__xs u--text--sm u--text--light\"],[12],[1,\"\\n                \"],[1,[28,[35,2],[\"posts.modal.instagram.n_connected_devices\"],[[\"count\"],[[30,0,[\"socialProfileDeviceCount\"]]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[1,\"              \"],[10,2],[14,0,\"u--text--danger u--text--sm u--m__b__xs\"],[12],[1,\"\\n                \"],[1,[28,[35,2],[\"stories.story_editor.video_too_long\"],[[\"length\"],[[30,6,[\"length\"]]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]]],[1,\"            \"],[11,3],[24,0,\"u--m__b__xs u--text--sm\"],[4,[38,3],[\"click\",[30,7]],null],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"stories.story_editor.how_to_publish\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"],[41,[30,0,[\"isPostedStory\"]],[[[1,\"        \"],[10,0],[14,0,\"cSE--galleryWrapper eSE--galleryWrapper\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"cSE--gallery\"],[12],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,4,[\"postMediaItems\"]]],null]],null],null,[[[1,\"              \"],[10,1],[14,0,\"cSE--gallery__item\"],[12],[1,\"\\n                \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n                  \"],[10,\"img\"],[15,\"src\",[30,8,[\"medResUrl\"]]],[14,0,\"o--media cSE--gallery__media\"],[12],[13],[1,\"\\n                  \"],[10,\"b\"],[14,0,\"o--mediaOverlay\"],[12],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[8]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"cSE--galleryWrapper cSE--galleryWrapper--hasBtn eSE--galleryWrapper\"],[12],[1,\"\\n          \"],[11,3],[24,0,\"o--btn--sm o--btn--outline o--btn--c cSE--galleryBtn cSE--galleryBtn--left\"],[4,[38,3],[\"click\",[28,[37,7],[[30,0,[\"scrollToLeftBy\"]],150],null]],null],[12],[1,\"\\n            \"],[1,[28,[35,8],[\"nav-left\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[11,\"ul\"],[24,0,\"cSE--gallery\"],[4,[38,9],[[30,0,[\"scrollbarId\"]]],[[\"wheelPropagation\",\"maxScrollbarLength\"],[true,150]]],[12],[1,\"\\n            \"],[8,[39,10],null,[[\"@postMediaItems\",\"@canCropOnPost\",\"@canDeleteStoryItems\",\"@groupId\",\"@storyVideoMaxLength\",\"@editPMICrop\",\"@deleteStoryItem\"],[[30,0,[\"postMediaItems\"]],[30,0,[\"canCropOnPost\"]],[30,0,[\"canDeleteStoryItems\"]],[30,0,[\"currentGroup\",\"id\"]],[30,9],[30,10],[30,0,[\"deleteStoryItem\"]]]],null],[1,\"\\n            \"],[10,\"li\"],[14,0,\"cSE--gallery__item is--empty\"],[12],[1,\"\\n\"],[41,[30,0,[\"showDropZone\"]],[[[1,\"                \"],[10,0],[14,0,\"cDZ--dropzone\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"              \"],[10,1],[12],[1,\"\\n\"],[41,[30,0,[\"showDropZone\"]],[[[1,\"                  \"],[1,[28,[35,8],[\"add-circle\"],[[\"class\"],[\"o--icon o--icon--hl cSE--gallery__icon--empty\"]]]],[1,\"\\n\"]],[]],[[[1,\"                  \"],[1,[28,[35,8],[\"add-circle\"],[[\"class\"],[\"o--icon o--icon--light cSE--gallery__icon--empty\"]]]],[1,\"\\n\"]],[]]],[1,\"                \"],[8,[39,11],null,[[\"@delay\",\"@side\"],[100,\"top\"]],[[\"default\"],[[[[1,\"\\n                  \"],[1,[28,[35,2],[\"stories.story_editor.dropzone_tooltip\"],null]],[1,\"\\n                \"]],[]]]]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n            \"],[10,\"li\"],[14,0,\"cSE--gallery__item cSE--gallery__item--textarea\"],[12],[1,\"\\n              \"],[10,\"label\"],[14,0,\"u--block\"],[12],[1,\"\\n                \"],[1,[28,[35,2],[\"stories.story_editor.textarea_label\"],null]],[1,\"\\n              \"],[13],[1,\"\\n              \"],[8,[39,12],[[24,0,\"cSE--gallery__textarea\"],[16,\"placeholder\",[28,[37,2],[\"stories.story_editor.textarea_placeholder\"],null]],[24,\"data-test-id\",\"clipboard-text-area\"]],[[\"@value\"],[[30,4,[\"caption\"]]]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n          \"],[11,3],[24,0,\"o--btn--sm o--btn--outline o--btn--c cSE--galleryBtn cSE--galleryBtn--right\"],[4,[38,3],[\"click\",[28,[37,7],[[30,0,[\"scrollToRightBy\"]],150],null]],null],[12],[1,\"\\n            \"],[1,[28,[35,8],[\"nav-right\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@clearSelectedStory\",\"@notNewAndHasChanges\",\"@discardChangesAndClose\",\"@story\",\"@hasUnsavedChanges\",\"@invalidLengthStoryVideos\",\"@toggleTutorialModal\",\"postMediaItem\",\"@storyVideoMaxLength\",\"@editPMICrop\"],false,[\"if\",\"calendar/stories/drop-zone\",\"t\",\"on\",\"shared/date-time-picker\",\"each\",\"-track-array\",\"fn\",\"svg-jar\",\"perfect-scroll\",\"calendar/stories/thumbnails\",\"ember-tooltip\",\"textarea\"]]",
    "moduleName": "calendar/components/calendar/stories/editor.hbs",
    "isStrictMode": false
  });

  const DATE_FORMAT_STRING = 'MMM D h:mm a';
  let EditorComponent = (_class = (_formatStoryTime = /*#__PURE__*/new WeakSet(), class EditorComponent extends _component2.default {
    get canDeleteStoryItems() {
      return this.postMediaItems.length > 1;
    }

    get currentGroup() {
      return this.auth.currentGroup;
    }

    get isPostedStory() {
      return this.args.story.isPosted;
    }

    get postMediaItems() {
      const postMediaItems = this.args.story.postMediaItems;
      return postMediaItems.filter(pmi => !pmi.isRemoved);
    }

    get showDropZone() {
      return this.args.isDragging && !this.isPostedStory;
    }

    get socialProfileDeviceCount() {
      var _socialProfile$get;

      const socialProfile = this.args.story.socialProfile;
      return ((_socialProfile$get = socialProfile.get('devices')) === null || _socialProfile$get === void 0 ? void 0 : _socialProfile$get.length) || 0;
    }

    get timeZoneIdentifier() {
      var _this$userConfig$curr;

      return (_this$userConfig$curr = this.userConfig.currentTimeZone) === null || _this$userConfig$curr === void 0 ? void 0 : _this$userConfig$curr.identifier;
    }

    get canSaveStory() {
      return (0, _utils.isEmpty)(this.args.invalidLengthStoryVideos);
    }

    get storySecondsTotalTime() {
      if (!(0, _utils.isNone)(this.args.story)) {
        const pmiTimes = this.postMediaItems.map(pmi => Number(pmi.storySecondDuration));
        return (0, _utils.isEmpty)(pmiTimes) ? 0 : pmiTimes.reduce((total, pmiTime) => total + pmiTime);
      }

      return null;
    }

    get storyFormattedStartTime() {
      return _classPrivateMethodGet(this, _formatStoryTime, _formatStoryTime2).call(this, this.args.story.startTime);
    }

    get storyFormattedEndTime() {
      return _classPrivateMethodGet(this, _formatStoryTime, _formatStoryTime2).call(this, this.args.story.storyEndTime);
    }

    get storyFormattedPostedTime() {
      return _classPrivateMethodGet(this, _formatStoryTime, _formatStoryTime2).call(this, _moment.default.unix(this.args.story.postedTime));
    }

    get storyFormattedTotalTime() {
      if (this.storySecondsTotalTime) {
        return (0, _timeFormat.timeFormat)(Math.floor(this.storySecondsTotalTime));
      }
    }

    get canCropOnPost() {
      return !this.args.story.locked && !this.args.story.isSaving;
    }

    constructor(owner, args) {
      super(owner, args);

      _classPrivateMethodInitSpec(this, _formatStoryTime);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "userConfig", _descriptor3, this);

      _initializerDefineProperty(this, "perfectScroll", _descriptor4, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor5, this);

      _defineProperty(this, "scrollbarId", void 0);

      this.scrollbarId = (0, _uuid.default)();
    }

    discardStory() {
      this.dialogManager.confirm(this.intl.t('stories.story_editor.discard_confirm'), {
        confirmButton: this.intl.t('shared_words.delete')
      }).then(() => this.args.deleteStory(this.args.story));
    }

    saveStory() {
      this.args.saveStory(this.args.story);
    }

    addMediaToStory(dragEvent) {
      var _dragEvent$dataTransf;

      const draggedItemIds = (_dragEvent$dataTransf = dragEvent.dataTransfer) === null || _dragEvent$dataTransf === void 0 ? void 0 : _dragEvent$dataTransf.getData('text');

      if (!(0, _utils.isNone)(draggedItemIds)) {
        const ids = draggedItemIds.split(',');
        this.args.addToStory(ids);
      }
    }

    updateScheduledTime(_selectedDates, timestamp) {
      this.args.story.scheduledTime = timestamp;
    }

    deleteStoryItem(item) {
      if (item.get('isNew')) {
        item.deleteRecord();
      }
    }

    scrollToRight() {
      this.perfectScroll.scrollToRight(this.scrollbarId);
    }

    scrollToRightBy(px) {
      this.perfectScroll.scrollToRightBy(this.scrollbarId, px);
    }

    scrollToLeftBy(px) {
      this.perfectScroll.scrollToLeftBy(this.scrollbarId, px);
    }

  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "perfectScroll", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "discardStory", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "discardStory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveStory", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "saveStory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addMediaToStory", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addMediaToStory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateScheduledTime", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateScheduledTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteStoryItem", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteStoryItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scrollToRight", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "scrollToRight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scrollToRightBy", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "scrollToRightBy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "scrollToLeftBy", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "scrollToLeftBy"), _class.prototype)), _class);
  _exports.default = EditorComponent;

  function _formatStoryTime2(time) {
    if (time && this.timeZoneIdentifier) {
      return (0, _moment.default)(time).tz(this.timeZoneIdentifier).format(DATE_FORMAT_STRING);
    }

    return (0, _moment.default)().format(DATE_FORMAT_STRING);
  }

  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, EditorComponent);
});